import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../common/types';
import type { ReplyThread } from '../outreachTypes';
import { shortDate } from '../outreachFormat';
import { inboxMessages as messages } from './inboxMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Inbox.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A placement in a thread (design outreach g2): found in the playlist data even with no reply. */
const PlacementBoxComponent: React.FC<{ song: string; placement: NonNullable<ReplyThread['placement']> }> = ({
  song,
  placement,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.placed} data-testid="placement-box">
      <FontAwesomeIcon icon={faCheck} className={styles.placedIcon} />
      <div className={shared.grow}>
        <b>
          {intl.formatMessage(messages.placedTitle, {
            song,
            playlist: placement.targetName,
            date: shortDate(intl, placement.foundAt),
          })}
        </b>
        {placement.source === 'detected' && (
          <p className={shared.small}>{withBrandWord(intl.formatMessage(messages.placedDetected))}</p>
        )}
        {placement.position !== null && (
          <p className={shared.small}>
            {intl.formatMessage(messages.placedPosition, { position: placement.position })}
          </p>
        )}
        <p className={shared.small}>{withBrandWord(intl.formatMessage(messages.placedWatch))}</p>
      </div>
    </div>
  );
};

export const PlacementBox = TypedMemo(PlacementBoxComponent);
